import React, { useState, useEffect } from "react";
import Header from "../components/Header.jsx";
import Footer from "../components/Footer.jsx";
import Loader from "../components/Loader.jsx";
import ErrorPage from "./ErrorPage.jsx";
import "../styles/pages/subpages/government-procurements_page.css";

import ChevronRightIcon from "../assets/icons/chevron-right.svg";
import GovernmentProcurementsPageImage from "../assets/images/government-procurements_image.png";

import PhoneIcon from "../assets/icons/phone-icon.svg";
import AtIcon from "../assets/icons/at-icon.svg";

import { fetchZakupki } from "../services/apiService.js";

const GovernmentProcurementsPage = () => {
  const [zakupkiData, setZakupkiData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const data = await fetchZakupki();
        setZakupkiData(data);
      } catch (error) {
        setError(error);
        console.error("Ошибка загрузки данных", error);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  if (isLoading) {
    return (
      <div className="loader-wrapper">
        <Loader />
        <p className="loading-text">Загрузка...</p>
      </div>
    );
  }

  if (error) {
    return <ErrorPage />;
  }

  return (
    <div className="government-procurements-page">
      <Header />
      <nav className="page-nav">
        <a href="/" className="nav-link">
          Главная
        </a>
        <img
          src={ChevronRightIcon}
          alt="Chevron"
          className="nav-chevron-icon"
        />
        <span className="nav-link">Закупки</span>
      </nav>

      <div className="government-procurements-page-content">
        <h2 className="gradient-page-title">
          Закупки и тендерные торги
        </h2>
        <img
          src={GovernmentProcurementsPageImage}
          alt="Government procurements pic"
          className="government-procurements-image"
        />
        <div className="government-procurements-page-text-section">
          <h2 className="section-title">
            ОсОО "ШНОС" открыто к сотрудничеству, как с корпоративными клиентами,
            так и с государственными органами.
          </h2>
          <p className="government-procurements-text">
            Наша компания владеет обширной сетью АЗС в г. Бишкек, Чуйской и
            Иссык-Кульской областях, а так же тремя нефтехранилищами, что
            позволяет компании составлять конкуренцию другим представителям
            нефтяного бизнеса в Кыргызстане.
          </p>

          {zakupkiData.map((item) => (
            <div key={item.id}>
              {item.description && (
                <p className="government-procurements-text">{item.description}</p>
              )}
            </div>
          ))}
        </div>
        <div className="contact-block government-procurements-contact-block">
          <h3 className="contact-title">
            По вопросам касающихся конкурсных торгов и государственных закупок:
          </h3>
          <div className="contact-content">
            <div className="contact-item">
              <img src={PhoneIcon} alt="Phone Icon" className="icon" />
              <span className="contact-text">
                тел.: <span className="number">+996 (312) 303 303</span>, (доб. 138)
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                тел.: <span className="number">+996 (556) 706 146</span>
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                тел.: <span className="number">+996 (700) 706 146</span>
              </span>
            </div>
            <div className="contact-item">
              <span className="contact-text">
                тел.: <span className="number">+996 (700) 706 146</span>
              </span>
            </div>
            <div className="contact-item">
              <img src={AtIcon} alt="Email Icon" className="icon" />
              <span className="contact-text">
                эл. адрес: <u className="email">tender@bpetroleum.kg</u>
              </span>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default GovernmentProcurementsPage;
